import { render } from "./SolarSimpleSubProduct.vue?vue&type=template&id=f9eaed66"
import script from "./SolarSimpleSubProduct.vue?vue&type=script&lang=js"
export * from "./SolarSimpleSubProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__